<template>
  <div>
    <el-drawer title="查找我的基层工作单位" size="55%" :visible.sync="visible">
      <el-row>
        <el-col :span="19" :offset="1">
          <el-input
            v-model="keyword"
            maxlength="30"
            show-word-limit
            placeholder="请输入单位名称(至少输入4个字符)"
          ></el-input>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button
            size="medium"
            icon="el-icon-search"
            @click="searchDept"
          ></el-button>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        fit
        stripe
        class="mt10"
        :empty-text="emptyText"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column
          property="deptNo"
          label="单位编号"
          width="150"
        ></el-table-column>
        <el-table-column property="deptName" label="单位名称"></el-table-column>
        <el-table-column
          property="manager"
          label="联系人"
          width="150"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="100"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleSelectd(scope.row)"
              >确认选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { searchDept } from "@/api/tdcs/dept.js";

export default {
  data() {
    return {
      keyword: "",
      visible: false,
      loading: false,
      tableData: [],
      emptyText: "输入关键字，点击放大镜查询",
    };
  },
  methods: {
    handleSelectd(row) {
      this.visible = false;
      this.$emit("selectd", row.deptId, row.deptName);
    },
    searchDept() {
      if (!this.keyword) {
        this.msgError("请输入单位名称!");
        return;
      }
      if (this.keyword && this.keyword.length < 4) {
        this.msgError("单位名称(至少输入4个字符)!");
        return;
      }
      this.loading = true;
      searchDept(this.keyword).then((res) => {
        this.tableData = res;
        this.loading = false;
        this.emptyText = "暂无数据";
      });
    },
    show() {
      this.visible = true;
    },
  },
};
</script>